import axios from "@/plugins/axios";

let url = "/api/v1/easyleg/settings";

export const settings = {
    get(){
        return axios.get(`${url}`).then(result => result.data);
    },
}